var _templateObject, _templateObject2;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
import MuiAvatar from '@material-ui/core/Avatar';
var sizeFn = function sizeFn(size) {
  var sizes = {
    large: 50,
    medium: 40,
    small: 30
  };
  return sizes[size];
};
export var StyledAvatar = styled(MuiAvatar)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    && {\n      width: ", "px;\n      height: ", "px;\n    }\n  "])), sizeFn(size), sizeFn(size));
});